/* Ecochic · Catálogo con filtros combinables (FLUJO_FRONTEND_ECOCHIC_v1 §1), portado de web-v3/js/views/catalogo.js.
   Cambios al portar (PLAN v2 §5): «Tipo de piel» y «Quiero mejorar» leen los tags canónicos piel:* / dolencia:*
   (y custom.tipos_piel / custom.dolencias); solo si el producto no tiene ninguno se usa el vocabulario de texto de web-v3.
   Se añade el chip «Piel sensible / barrera» (dolencia:sensibilidad). «Protección solar» ya no usa «uva» como palabra
   (falso positivo de «pepita de uva»). Tipo de producto = product_type de la tienda. Sin conceptos de envío (entrega-*).
   Textos de la sección en script#eco-catalog-config. */
(function () {
  'use strict';
  var el = document.getElementById('eco-catalog');
  if (!el) return;
  var T = {};
  try { T = JSON.parse(document.getElementById('eco-catalog-config').textContent) || {}; } catch (e) {}
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function na(s) { return (s == null ? '' : String(s)).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function eur(v) { var n = parseFloat(v); return (isNaN(n) || n === 0) ? '' : n.toFixed(2).replace('.', ',') + ' €'; }
  function slugify(s) { return na(s).replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function uniq(arr) { var seen = {}, out = []; (arr || []).forEach(function (x) { var k = na(x); if (x != null && x !== '' && !seen[k]) { seen[k] = 1; out.push(x); } }); return out; }

  /* perfil (eco-core.js) */
  function P_() { return window.Eco && Eco.Profile; }
  function personalized() { try { return !!(P_() && P_().personalized()); } catch (e) { return false; } }
  function ecoP(p) {
    try {
      var ex = (window.PRODUCTS_EXTRA || {})[p.h] || {};
      return Eco.data.toP({ handle: p.h, title: p.t, description: p.desc, product_type: p.product_type, tags: p.tags,
        custom: { inci: p.inci, activos_clave: ex.activos || [], tipos_piel: ex.piel || [] } });
    } catch (e) { return null; }
  }
  function fitLevel(p) { try { return (P_().fitStatus(ecoP(p)) || {}).level || 'none'; } catch (e) { return 'none'; } }
  function profileIdeal(p) { try { return !!P_().isIdeal(ecoP(p)); } catch (e) { return false; } }
  function fitTag(p) { try { return Eco.fitTag(ecoP(p), true) || ''; } catch (e) { return ''; } }

  /* vocabularios: metaobjeto «Vocabulario» (grupos piel_catalogo / dolencia_catalogo): nombre, etiquetas canónicas y palabras clave */
  var D = window.ECO_DATA || {};
  var PIEL = D.group ? D.group('piel_catalogo') : [];
  var DOL = D.group ? D.group('dolencia_catalogo') : [];
  var PIEL_FREE = PIEL.filter(function (v) { return !v.tags.length; }); // sin etiqueta canónica (p. ej. «Madura»): siempre por palabras clave
  var DOL_FREE = DOL.filter(function (v) { return !v.tags.length; });
  var PRICES = [
    { key: 'p1', label: EcoT('catalogo.menos_de_15'), min: 0, max: 15 }, { key: 'p2', label: EcoT('catalogo.precio_15_30'), min: 15, max: 30 },
    { key: 'p3', label: EcoT('catalogo.precio_30_50'), min: 30, max: 50 }, { key: 'p4', label: EcoT('catalogo.precio_50_80'), min: 50, max: 80 },
    { key: 'p5', label: EcoT('catalogo.mas_de_80'), min: 80, max: Infinity }
  ];
  // la palabra clave también se normaliza (tildes y mayúsculas del metaobjeto); sin recortar: « edad» lleva el espacio a propósito
  function matchVocab(list, text) { var t = na(text), out = []; list.forEach(function (v) { if (v.kw.some(function (k) { var n = na(k); return n && t.indexOf(n) >= 0; })) out.push(v.key); }); return out; }
  function labelFor(list, key) { for (var i = 0; i < list.length; i++) if (list[i].key === key) return list[i].label; return key; }
  // etiquetas con prefijo (piel:, dolencia:, activo:) = identificadores; nunca se pintan en bruto (apartado 9 g)
  var PREFIX_RX = /^(piel|dolencia|activo)\s*[:\-]\s*(.+)$/;
  function prefixed(t) { var m = PREFIX_RX.exec(na(t).trim()); return m ? { kind: m[1], key: m[2].trim() } : null; }
  function nameFor(list, key) { for (var i = 0; i < list.length; i++) if (slugify(list[i].key) === slugify(key)) return list[i]; return null; }
  function priceBand(p) { var n = parseFloat(p.price); if (isNaN(n) || n <= 0) return null; for (var i = 0; i < PRICES.length; i++) if (n >= PRICES[i].min && n < PRICES[i].max) return PRICES[i].key; return null; }

  var P = [], I = null, ING = [];
  function canon(p, prefix) {
    var out = [];
    (p.tags || []).forEach(function (t) { var n = na(t).replace(/\s+/g, ''); if (n.indexOf(prefix + ':') === 0) out.push(n.slice(prefix.length + 1)); });
    return out;
  }
  function productText(p) {
    var x = (window.PRODUCTS_EXTRA || {})[p.h] || {};
    return na([p.t, p.desc, (p.tags || []).join(' '), p.inci, (x.activos || []).join(' '), (x.piel || []).join(' '), (x.beneficios || []).join(' '), x.modo_uso].filter(Boolean).join('  '));
  }
  // Corrección al portar: un token genérico suelto («extract», «water»…) de un INCI partido por «/» casaba con casi todo
  var GENERIC = /^(extract|water|oil|seed oil|leaf|flower|juice|butter|acid|powder|fruit)$/;
  function ingTokens(ing) { return [ing.inci, ing.nombre].filter(Boolean).join('/').split('/').map(function (s) { return na(s.trim()); }).filter(function (s) { return s.length > 3 && !GENERIC.test(s); }); }
  function buildIndex() {
    I = { byHandle: {}, ingCount: {}, ingBySlug: {} };
    ING.forEach(function (ing) { I.ingBySlug[ing.slug] = ing; I.ingCount[ing.slug] = 0; });
    P.forEach(function (p) {
      var text = productText(p);
      var activeTags = canon(p, 'activo');
      var matched = ING.filter(function (ing) { return activeTags.indexOf(ing.slug) >= 0 || ingTokens(ing).some(function (t) { return text.indexOf(t) >= 0; }); });
      matched.forEach(function (ing) { I.ingCount[ing.slug]++; });
      // Piel: canónica (piel:* y custom.tipos_piel); vocabulario de texto solo si no hay ninguna
      var pc = uniq(canon(p, 'piel').concat((p.piel || []).map(na)));
      var piel = [];
      PIEL.forEach(function (v) { if (v.tags.some(function (t) { return pc.indexOf(t) >= 0; })) piel.push(v.key); });
      if (!pc.length) {
        piel = piel.concat(matchVocab(PIEL, (p.tags || []).join(' ') + ' ' + (p.desc || '')));
        matched.forEach(function (ing) { (ing.para_piel || []).forEach(function (s) { piel = piel.concat(matchVocab(PIEL, s)); }); });
      } else {
        piel = piel.concat(matchVocab(PIEL_FREE, (p.tags || []).join(' ') + ' ' + (p.desc || '')));
      }
      // Quiero mejorar: canónica (dolencia:* y custom.dolencias); texto solo si no hay ninguna
      var dc = uniq(canon(p, 'dolencia').concat((p.dolencias || []).map(function (d) { return na(d).replace(/\s+/g, '_'); })));
      var dol = [];
      DOL.forEach(function (v) { if (v.tags.some(function (t) { return dc.indexOf(t) >= 0; })) dol.push(v.key); });
      if (!dc.length) {
        dol = dol.concat(matchVocab(DOL, (p.tags || []).join(' ') + ' ' + (p.t || '') + ' ' + (p.desc || '')));
        matched.forEach(function (ing) { (ing.dolencias || []).forEach(function (s) { dol = dol.concat(matchVocab(DOL, s)); }); });
      }
      // sin etiqueta canónica (p. ej. «Protección solar»): por palabras clave o por el paso del tipo de producto (relacionadas: «spf»)
      var tp = D.tipo ? D.tipo(p.product_type) : null;
      DOL_FREE.forEach(function (v) { if (matchVocab([v], (p.t || '') + ' ' + (p.tags || []).join(' ')).length || (tp && v.rel.indexOf(tp.paso) >= 0)) dol.push(v.key); });
      var inci = na(p.inci);
      I.byHandle[p.h] = { ingSlugs: matched.map(function (i) { return i.slug; }), piel: uniq(piel), dol: uniq(dol), std: p.ok === true,
        // C355: con INCI y sin ninguna de las entradas del metaobjeto «Alérgeno»; «parfum» solo no lo excluye (filtro.no_incluye).
        // Sin lista cargada no hay filtro (nunca «sin alérgenos» por falta de datos).
        fragFree: !!inci && !!(D.hasAlergenos && D.hasAlergenos()) && !D.alergeno(p.inci) };
    });
  }

  function deepParam() {
    var q = null; try { q = new URLSearchParams(location.search).get('f'); } catch (e) {}
    if (q) return q;
    var m = /^#\/catalogo\/(.+)$/.exec(location.hash || '') || /^#([\w.~-]+)$/.exec(location.hash || '');
    try { return m ? decodeURIComponent(m[1]) : null; } catch (e) { return null; }
  }
  // Vista rápida (FLUJO F2 reglas 27-29): etiqueta de encaje, marca, nombre, precio, Estándar/En revisión,
  // 200 caracteres de descripción, «Añadir a la cesta» y «Ver ficha completa». Fondo, × o Escape cierran y devuelven el foco.
  var qvLast = null;
  function qvModal() {
    var m = document.getElementById('ecQv'); if (m) return m;
    m = document.createElement('div'); m.id = 'ecQv'; m.className = 'ec-qv-modal eco-catalog'; m.hidden = true;
    m.innerHTML = '<div class="ec-qv-bg" data-qv-close></div><div class="ec-qv-panel" role="dialog" aria-modal="true" aria-label="' + esc(EcoT('catalogo.qv_dialog')) + '">' +
      '<button type="button" class="ec-qv-x" data-qv-close aria-label="' + esc(EcoT('catalogo.qv_close')) + '">×</button><div class="ec-qv-body"></div></div>';
    document.body.appendChild(m);
    m.addEventListener('click', function (e) { if (e.target.closest('[data-qv-close]')) qvClose(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !m.hidden) qvClose(); });
    return m;
  }
  function qvClose() {
    var m = document.getElementById('ecQv'); if (!m) return;
    m.hidden = true; document.documentElement.style.overflow = '';
    try { if (qvLast) qvLast.focus(); } catch (e) {} qvLast = null;
  }
  function qvOpen(h, trigger) {
    var p = null; (P || []).forEach(function (x) { if (x.h === h) p = x; }); if (!p) return;
    var m = qvModal(), price = eur(p.price), tag = fitTag(p), url = p.u || (ROOT + 'products/' + p.h);
    var soldOut = p.available === false;
    var brief = String(p.desc || '').slice(0, 200) + (String(p.desc || '').length > 200 ? '…' : '');
    m.querySelector('.ec-qv-body').innerHTML =
      '<div class="ec-qv-img">' + (tag ? '<span class="ec-tag">' + tag + '</span>' : '') + (p.img ? '<img src="' + esc(p.img) + '" alt="' + esc(p.t) + '">' : '') + '</div>' +
      '<div class="ec-qv-info"><p class="ec-brand">' + esc(p.brand || EcoT('catalogo.clean_beauty')) + '</p>' +
      '<p class="ec-qv-name">' + esc(p.t) + '</p>' +
      '<p class="ec-qv-price">' + (price ? '<b>' + price + '</b>' : '<span class="ec-muted">' + esc(EcoT('catalogo.qv_ask')) + '</span>') +
      // sello del Estándar solo si el producto lo tiene (custom.estandar_ok); sin dato no se pinta nada (fase 1: sello aplazado)
      (p.ok === true ? ' <span class="ec-qv-badge">' + esc(EcoT('catalogo.qv_standard')) + '</span>' : '') + '</p>' +
      (brief ? '<p class="ec-qv-desc">' + esc(brief) + '</p>' : '') +
      (p.slow && D.slow ? '<div class="ec-qv-slow"><p class="ec-slow inventory-low-stock-status">' + esc(D.slow.status) + '</p>' + (D.slow.delivery ? '<p class="ec-qv-desc">' + esc(D.slow.delivery) + '</p>' : '') +
        (D.slow.url ? '<a class="ec-qv-slowlink" href="' + esc(D.slow.url) + '">' + esc(D.slow.label) + '</a>' : '') + '</div>' : '') +
      // agotado: «Añadir» desactivado con el texto de agotado; lo que se sigue vendiendo sin stock cuenta como disponible (p.available)
      '<div class="ec-qv-acts"><button type="button" class="button button-solid eco-btn leading-normal text-center pl-6 pr-6 pt-2 pb-2" data-qv-add="' + esc(p.h) + '"' + (soldOut ? ' disabled aria-disabled="true"' : '') + '>' + esc(soldOut ? EcoT('catalogo.qv_sold_out') : EcoT('catalogo.qv_add')) + '</button>' +
      '<a class="button button-outline eco-btn leading-normal text-center pl-6 pr-6 pt-2 pb-2" href="' + esc(url) + '">' + esc(EcoT('catalogo.qv_full')) + '</a></div></div>';
    var add = m.querySelector('[data-qv-add]');
    add.addEventListener('click', function () {
      if (soldOut) return;
      if (window.EcoCart) EcoCart.add(p.h).then(function (n) { if (n) { add.textContent = EcoT('catalogo.qv_added'); setTimeout(function () { add.textContent = EcoT('catalogo.qv_add'); }, 1300); } }, function () {});
    });
    qvLast = trigger || null;
    m.hidden = false; document.documentElement.style.overflow = 'hidden';
    try { m.querySelector('.ec-qv-x').focus(); } catch (e) {}
  }
  function card(p) {
    var price = eur(p.price), url = p.u || (ROOT + 'products/' + p.h), tag = fitTag(p);
    return '<div class="ec-cardwrap"><button type="button" class="ec-qv" data-qv="' + esc(p.h) + '">' + esc(EcoT('catalogo.qv_button')) + '</button><a class="ec-card" href="' + esc(url) + '">' +
      '<span class="ec-img">' + (tag ? '<span class="ec-tag">' + tag + '</span>' : '') +
        (p.img ? '<img loading="lazy" src="' + esc(p.img) + '" alt="' + esc(p.t) + '">' : '') + '</span>' +
      '<span class="ec-body"><span class="ec-brand">' + esc(p.brand || EcoT('catalogo.clean_beauty')) + '</span>' +
        '<span class="ec-name">' + esc(p.t) + '</span>' +
        (p.slow && D.slow ? '<span class="ec-slow inventory-low-stock-status">' + esc(D.slow.status) + '</span>' : '') + // Slow Beauty: se vende sin stock, bajo reserva
        '<span class="ec-foot">' + (price ? '<span class="ec-price">' + price + '</span>' : '<span class="ec-price ec-muted">' + EcoT('core.consultar') + '</span>') +
        '<span class="ec-seal">' + (p.ok === true ? EcoT('core.sello_corto') : '·') + '</span></span></span></a></div>';
  }

  function mount() {
    P = (window.PRODUCTS || []).filter(function (p) { return !(D.isService && D.isService(p.h)); });
    ING = window.INGREDIENTS || [];
    if (!P.length) { el.innerHTML = '<p class="ec-muted">'+EcoT('catalogo.no_hay_productos_cargados')+'</p>'; return; }
    buildIndex();
    var brands = uniq(P.map(function (p) { return p.brand; }).filter(Boolean)).sort(function (a, b) { return a.localeCompare(b); });
    var typeCount = {}; P.forEach(function (p) { if (p.product_type) typeCount[p.product_type] = (typeCount[p.product_type] || 0) + 1; });
    var types = Object.keys(typeCount).sort(function (a, b) { return typeCount[b] - typeCount[a]; });
    var actives = ING.map(function (i) { return i.slug; }).filter(function (s) { return I.ingCount[s] > 0; }).sort(function (a, b) { return I.ingCount[b] - I.ingCount[a]; });
    var nofragCount = P.filter(function (p) { return I.byHandle[p.h].fragFree; }).length;
    var stdCount = P.filter(function (p) { return I.byHandle[p.h].std; }).length; // sin estandar_ok cargado, sin filtro (apartado 8 f)

    var state = { brand: {}, type: {}, piel: {}, dol: {}, act: {}, price: {}, tag: {}, sello: false, forme: false, nofrag: false, sort: 'rel' };
    var perso = personalized();
    // regla 7: con perfil y personalización, entra en «Para mí»; si se llega desde un enlace con filtro, se muestra solo lo pulsado
    if (perso && !deepParam()) state.forme = true;

    // enlace profundo ?f=<param> o #/catalogo/<param> (regla 8)
    (function (param) {
      if (!param) return; var k = na(param), i;
      for (i = 0; i < DOL.length; i++) if (na(DOL[i].key) === k || na(DOL[i].label) === k) { state.dol[DOL[i].key] = true; return; }
      for (i = 0; i < PIEL.length; i++) if (na(PIEL[i].key) === k || na(PIEL[i].label) === k) { state.piel[PIEL[i].key] = true; return; }
      if (k === 'sello' || k === 'estandar') { if (stdCount) state.sello = true; return; }
      if (k === 'sin-perfume' || k === 'nofrag') { if (nofragCount) state.nofrag = true; return; }
      for (i = 0; i < types.length; i++) if (na(types[i]) === k) { state.type[types[i]] = true; return; }
      for (i = 0; i < brands.length; i++) if (slugify(brands[i]) === slugify(param) || na(brands[i]) === k) { state.brand[brands[i]] = true; return; }
      if (I.ingBySlug[param]) { state.act[param] = true; return; }
      if (k === 'para-mi' || k === 'forme') { if (perso) state.forme = true; return; } // sin perfil (o con el ajuste del perfil apagado) no hay «Para mí»
      // C358: piel:, dolencia: y activo: tienen su filtro con nombre; nunca entran como etiqueta
      var pf = prefixed(param);
      if (pf) {
        var hit = pf.kind === 'piel' ? nameFor(PIEL, pf.key) : pf.kind === 'dolencia' ? nameFor(DOL, pf.key) : null;
        if (hit) state[pf.kind === 'piel' ? 'piel' : 'dol'][hit.key] = true;
        else if (pf.kind === 'activo' && I.ingBySlug[pf.key]) state.act[pf.key] = true;
        return;
      }
      // etiqueta de producto (p. ej. VEGAN, Cruelty-free): desde el Estándar
      for (i = 0; i < P.length; i++) { var tg = (P[i].tags || []).filter(function (t) { return !prefixed(t) && slugify(t) === slugify(param); })[0]; if (tg) { state.tag[tg] = true; return; } }
    })(deepParam());
    var arrived = !!deepParam();

    function isOn(kind, val) { return kind === 'sello' ? state.sello : kind === 'forme' ? state.forme : kind === 'nofrag' ? state.nofrag : !!state[kind][val]; }
    function chip(kind, val, label, n) {
      var on = isOn(kind, val);
      return '<button class="ec-chip' + (on ? ' on' : '') + '" type="button" aria-pressed="' + (on ? 'true' : 'false') + '" data-kind="' + kind + '" data-val="' + esc(val) + '">' + esc(label) + '<span class="n">' + (n != null ? n : '') + '</span></button>';
    }
    /* Filtro plegable (selector): la cabecera abre y cierra; dentro, las opciones. Las que darían 0 o que cumplen
       todos los productos de la página se ocultan en facets(); el selector solo se oculta si no le queda ninguna. */
    var GSEQ = 0;
    function fbox(title, inner, extra) {
      var id = 'ecg-' + (++GSEQ);
      return '<div class="ec-fgroup"><button class="ec-fhead" type="button" aria-expanded="false" aria-controls="' + id + '">' +
        '<span class="ec-ftitle">' + esc(title) + '</span><span class="ec-fsel" data-fsel></span>' +
        '<svg class="ec-fchev" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg></button>' +
        '<div class="ec-fbody" id="' + id + '" hidden><div class="ec-chips">' + inner + '</div>' + (extra || '') + '</div></div>';
    }
    function group(title, kind, items, labelFn) {
      if (!items.length) return '';
      return fbox(title, items.map(function (it) {
        var val = (typeof it === 'string') ? it : it.key;
        return chip(kind, val, labelFn ? labelFn(it) : it);
      }).join(''));
    }

    el.innerHTML =
      (T.intro ? '<p class="ec-intro">' + esc(String(T.intro).replace('[n]', P.length)) + '</p>' : '') +
      '<div class="ec-layout">' +
        '<button class="ec-ftoggle" type="button" aria-expanded="false" aria-controls="ecFilters">' + esc(T.toggle || EcoT('catalogo.filtrar_y_ordenar')) + '<span class="n" data-ftn></span></button>' +
        '<aside class="ec-filters" id="ecFilters" aria-label="'+EcoT('catalogo.filtros_del_catalogo')+'">' +
          (perso ? fbox(EcoT('catalogo.tu_perfil'), chip('forme', '1', EcoT('catalogo.para_mi'))) : '') +
          group(EcoT('catalogo.tipo_de_piel'), 'piel', PIEL, function (v) { return v.label; }) +
          group(EcoT('catalogo.quiero_mejorar'), 'dol', DOL, function (v) { return v.label; }) +
          group(EcoT('catalogo.tipo_de_producto'), 'type', types) +
          group(EcoT('catalogo.activo'), 'act', actives, function (s) { return I.ingBySlug[s].nombre; }) +
          group(EcoT('catalogo.marca'), 'brand', brands) +
          group(EcoT('catalogo.precio'), 'price', PRICES, function (v) { return v.label; }) +
          ((stdCount || nofragCount) ? fbox(EcoT('catalogo.estandar_y_formula'), (stdCount ? chip('sello', '1', EcoT('catalogo.pasa_el_estandar')) : '') +
            (nofragCount ? chip('nofrag', '1', EcoT('catalogo.evito_el_perfume_parfum')) : ''),
            (nofragCount && T.ayuda_sin_alergenos ? '<p class="ec-fhelp">' + esc(T.ayuda_sin_alergenos) + '</p>' : '')) : '') +
        '</aside>' +
        '<div class="ec-main">' +
          '<div class="ec-toolbar"><span class="ec-count" role="status" aria-live="polite" data-count></span>' +
            '<div class="ec-tools"><label class="ec-sortwrap">'+EcoT('catalogo.ordenar')+' <select class="ec-sort" data-sort>' +
              '<option value="rel">'+EcoT('catalogo.relevancia')+'</option><option value="price-asc">'+EcoT('catalogo.precio_menor_a_mayor')+'</option><option value="price-desc">'+EcoT('catalogo.precio_mayor_a_menor')+'</option>' +
              '<option value="name">'+EcoT('catalogo.nombre_a_z')+'</option><option value="brand">'+EcoT('catalogo.marca_a_z')+'</option></select></label>' +
            '<button class="ec-clear" type="button" data-clear>'+EcoT('catalogo.limpiar_filtros')+'</button></div></div>' +
          '<div class="ec-active" aria-label="'+EcoT('catalogo.filtros_activos')+'" data-active></div>' +
          '<div class="ec-grid" data-grid></div>' +
        '</div></div>';

    var gridEl = el.querySelector('[data-grid]'), countEl = el.querySelector('[data-count]'), activeEl = el.querySelector('[data-active]');
    gridEl.addEventListener('click', function (e) { var q = e.target.closest('[data-qv]'); if (q) { e.preventDefault(); qvOpen(q.getAttribute('data-qv'), q); } });
    function keys(m) { return Object.keys(m).filter(function (k) { return m[k]; }); }
    function anyFilter() { return state.sello || state.forme || state.nofrag || ['brand', 'type', 'piel', 'dol', 'act', 'price', 'tag'].some(function (k) { return keys(state[k]).length; }); }
    /* Dentro de un filtro, las opciones suman (seca o mixta); entre filtros se cruzan (seca y además sérum) */
    var KINDS = ['forme', 'brand', 'type', 'sello', 'nofrag', 'piel', 'dol', 'act', 'price', 'tag'];
    /* Ajuste de la sección «Cómo se combinan las opciones»:
       'reduce' (por defecto): cada opción marcada es un requisito más (seca y mixta; rojeces y manchas). Tipo, marca y precio
         admiten una sola opción, porque un producto tiene un solo tipo, una marca y un precio.
       'suman': como antes, dentro de un filtro las opciones suman (seca o mixta) y entre filtros se cruzan. */
    var REDUCE = T.combinar !== 'suman';
    var SINGLE = { brand: 1, type: 1, price: 1 };
    function picked(kind) { return (kind === 'sello' || kind === 'forme' || kind === 'nofrag') ? (state[kind] ? ['1'] : []) : keys(state[kind]); }
    function optMatch(kind, val, p, d) {
      switch (kind) {
        case 'forme': return ['ideal', 'apt'].indexOf(fitLevel(p)) >= 0;
        case 'brand': return p.brand === val;
        case 'type': return p.product_type === val;
        case 'sello': return !!d.std;
        case 'nofrag': return !!d.fragFree;
        case 'piel': return d.piel.indexOf(val) >= 0;
        case 'dol': return d.dol.indexOf(val) >= 0;
        case 'act': return d.ingSlugs.indexOf(val) >= 0;
        case 'price': return priceBand(p) === val;
        case 'tag': return (p.tags || []).indexOf(val) >= 0;
      }
      return true;
    }
    function passes(p, skip) {
      var d = I.byHandle[p.h];
      for (var i = 0; i < KINDS.length; i++) {
        var k = KINDS[i]; if (k === skip) continue;
        var sel = picked(k);
        if (!sel.length) continue;
        var ok = (REDUCE && !SINGLE[k]) ? sel.every(function (v) { return optMatch(k, v, p, d); }) : sel.some(function (v) { return optMatch(k, v, p, d); });
        if (!ok) return false;
      }
      return true;
    }
    function filtered() { return P.filter(function (p) { return passes(p, null); }); }
    /* recuento de cada opción con lo demás marcado; se ocultan las que darían 0 y las que cumple toda la página (no cambian nada) */
    function facets() {
      var base = {};
      el.querySelectorAll('.ec-chip[data-kind]').forEach(function (c) {
        var kind = c.getAttribute('data-kind'), val = c.getAttribute('data-val'), on = isOn(kind, val);
        if (!base[kind]) base[kind] = P.filter(function (p) { return passes(p, REDUCE ? null : kind); });
        var n = base[kind].filter(function (p) { return optMatch(kind, val, p, I.byHandle[p.h]); }).length;
        if (c.__all == null) c.__all = P.every(function (p) { return optMatch(kind, val, p, I.byHandle[p.h]); });
        var nEl = c.querySelector('.n'); if (nEl) nEl.textContent = on ? '' : n;
        c.hidden = !on && (n === 0 || c.__all);
      });
      el.querySelectorAll('.ec-fgroup').forEach(function (g) {
        var vis = 0, sel = 0;
        g.querySelectorAll('.ec-chip').forEach(function (c) { if (!c.hidden) vis++; if (c.classList.contains('on')) sel++; });
        g.hidden = !vis;
        var fs = g.querySelector('[data-fsel]'); if (fs) fs.textContent = sel ? String(sel) : '';
      });
    }
    function openGroup(g, open) {
      var h = g.querySelector('.ec-fhead'), b = g.querySelector('.ec-fbody'); if (!h || !b) return;
      h.setAttribute('aria-expanded', open ? 'true' : 'false'); b.hidden = !open;
    }
    function sortList(list) {
      var s = state.sort;
      function pr(p) { var n = parseFloat(p.price); return isNaN(n) ? Infinity : n; }
      if (s === 'price-asc') return list.slice().sort(function (a, b) { return pr(a) - pr(b); });
      if (s === 'price-desc') return list.slice().sort(function (a, b) { return pr(b) - pr(a); });
      if (s === 'name') return list.slice().sort(function (a, b) { return (a.t || '').localeCompare(b.t || ''); });
      if (s === 'brand') return list.slice().sort(function (a, b) { return (a.brand || '').localeCompare(b.brand || '') || (a.t || '').localeCompare(b.t || ''); });
      if (perso) return list.slice().sort(function (a, b) { return (profileIdeal(b) ? 1 : 0) - (profileIdeal(a) ? 1 : 0); });
      return list;
    }
    var PILL = {
      forme: function () { return EcoT('catalogo.para_mi'); }, sello: function () { return EcoT('catalogo.pasa_el_estandar'); }, nofrag: function () { return EcoT('catalogo.evito_el_perfume_parfum'); },
      piel: function (v) { return labelFor(PIEL, v); }, dol: function (v) { return labelFor(DOL, v); },
      act: function (v) { return I.ingBySlug[v] ? I.ingBySlug[v].nombre : v; },
      price: function (v) { return labelFor(PRICES, v); }, type: function (v) { return v; }, brand: function (v) { return v; },
      // C360: con prefijo, el nombre del vocabulario o del ingrediente; sin nombre, sin píldora
      tag: function (v) {
        var pf = prefixed(v); if (!pf) return v;
        if (pf.kind === 'activo') return I.ingBySlug[pf.key] ? I.ingBySlug[pf.key].nombre : '';
        var hit = nameFor(pf.kind === 'piel' ? PIEL : DOL, pf.key); return hit ? hit.label : '';
      }
    };
    function renderActive() {
      var pills = [];
      if (state.forme) pills.push(['forme', '1']); if (state.sello) pills.push(['sello', '1']); if (state.nofrag) pills.push(['nofrag', '1']);
      ['piel', 'dol', 'type', 'act', 'brand', 'price', 'tag'].forEach(function (k) { keys(state[k]).forEach(function (v) { pills.push([k, v]); }); });
      activeEl.innerHTML = pills.map(function (pp) { var l = PILL[pp[0]](pp[1]); if (!l) return ''; return '<button class="ec-pill" type="button" aria-label="' + esc(EcoT('catalogo.quitar_filtro') + ' ' + l) + '" data-pill-kind="' + pp[0] + '" data-pill-val="' + esc(pp[1]) + '">' + esc(l) + '<span class="x" aria-hidden="true">×</span></button>'; }).join('');
      el.querySelector('[data-ftn]').textContent = pills.length ? ' (' + pills.length + ')' : '';
    }
    function render() {
      var list = sortList(filtered());
      countEl.innerHTML = EcoT('catalogo.n_de_total').replace('[n]', '<b>' + list.length + '</b>').replace('[total]', P.length) + ' ' + EcoT(list.length === 1 ? 'catalogo.producto' : 'catalogo.productos') +
        (state.forme && T.leyenda_perfil ? ' <span class="ec-legend">' + esc(T.leyenda_perfil) + '</span>' : ''); // Aviso B4 (C361)
      gridEl.innerHTML = list.length ? list.map(card).join('')
        : '<div class="ec-empty">'+EcoT('catalogo.no_hay_productos_con_esa_combinacion_d') + (anyFilter() ? ' <button class="ec-clear" type="button" data-clear>' + EcoT('catalogo.quitar_todos_los_filtros') + '</button>' : '') + '</div>';
      renderActive();
      facets();
    }
    function sync(kind) {
      el.querySelectorAll('.ec-chip[data-kind="' + kind + '"]').forEach(function (c) { var on = isOn(kind, c.getAttribute('data-val')); c.classList.toggle('on', on); c.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    }
    function toggle(kind, val) {
      if (kind === 'sello') state.sello = !state.sello; else if (kind === 'forme') state.forme = !state.forme; else if (kind === 'nofrag') state.nofrag = !state.nofrag; else state[kind][val] = !state[kind][val];
      // 'reduce': tipo, marca y precio, una sola opción a la vez
      if (REDUCE && SINGLE[kind] && state[kind][val]) { var only = {}; only[val] = true; state[kind] = only; }
      // 'suman': marcar todas las opciones que ofrece un filtro es lo mismo que no filtrar: se limpia ese filtro
      if (!REDUCE && state[kind] && typeof state[kind] === 'object') {
        var offered = Array.prototype.filter.call(el.querySelectorAll('.ec-chip[data-kind="' + kind + '"]'), function (c) { return !c.hidden || c.classList.contains('on'); });
        if (offered.length > 1 && offered.every(function (c) { return state[kind][c.getAttribute('data-val')]; })) state[kind] = {};
      }
      prune();
      KINDS.forEach(sync); render();
    }
    /* una opción marcada que, con lo marcado en los demás filtros, ya no aporta ningún producto se desmarca sola */
    function prune() {
      for (var guard = 0, changed = true; changed && guard < 10; guard++) {
        changed = false;
        KINDS.forEach(function (k) {
          var sel = picked(k); if (!sel.length) return;
          var base = P.filter(function (p) { return passes(p, k); });
          sel.forEach(function (v) {
            if (base.some(function (p) { return optMatch(k, v, p, I.byHandle[p.h]); })) return;
            if (k === 'sello' || k === 'forme' || k === 'nofrag') state[k] = false; else delete state[k][v];
            changed = true;
          });
        });
      }
    }
    function clearAll() {
      state = { brand: {}, type: {}, piel: {}, dol: {}, act: {}, price: {}, tag: {}, sello: false, forme: false, nofrag: false, sort: state.sort };
      el.querySelectorAll('.ec-chip.on').forEach(function (c) { c.classList.remove('on'); c.setAttribute('aria-pressed', 'false'); });
      render();
    }
    el.onclick = function (e) {
      var c = e.target.closest('.ec-chip'); if (c) { toggle(c.getAttribute('data-kind'), c.getAttribute('data-val')); return; }
      var pl = e.target.closest('[data-pill-kind]'); if (pl) { toggle(pl.getAttribute('data-pill-kind'), pl.getAttribute('data-pill-val')); return; }
      if (e.target.closest('[data-clear]')) { clearAll(); return; }
      var ft = e.target.closest('.ec-ftoggle');
      if (ft) { var open = el.querySelector('.ec-filters').classList.toggle('open'); ft.setAttribute('aria-expanded', open ? 'true' : 'false'); return; }
      var gh = e.target.closest('.ec-fhead'); if (gh) openGroup(gh.parentNode, gh.getAttribute('aria-expanded') !== 'true');
    };
    var sortEl = el.querySelector('[data-sort]');
    sortEl.addEventListener('change', function () { state.sort = this.value; render(); });
    render();
    // al entrar, abiertos solo los selectores que traen algo marcado
    // al entrar: abiertos los que traen algo marcado y, además, los primeros visibles (3 en escritorio, 1 en móvil; mismo corte que eco-catalogo.css)
    var isMobile = !!(window.matchMedia && window.matchMedia('(max-width: 860px)').matches), nOpen = isMobile ? 1 : 3;
    // en móvil «Filtrar y ordenar» llega desplegado (con solo el primer filtro abierto)
    if (isMobile) { var fp = el.querySelector('.ec-filters'), tg = el.querySelector('.ec-ftoggle'); if (fp && tg) { fp.classList.add('open'); tg.setAttribute('aria-expanded', 'true'); } }
    Array.prototype.filter.call(el.querySelectorAll('.ec-fgroup'), function (g) { return !g.hidden; }).forEach(function (g, i) {
      if (i < nOpen || g.querySelector('.ec-chip.on')) openGroup(g, true);
    });
    // llegada desde un enlace con filtro: se baja a los resultados para que se vea qué se ha filtrado (una vez)
    if (arrived && !window.__ecArrived) {
      window.__ecArrived = true;
      var go = function () { try { var y = countEl.getBoundingClientRect().top + window.scrollY - 120; window.scrollTo(0, Math.max(0, y)); } catch (e) {} };
      if (document.readyState === 'complete') setTimeout(go, 300); else window.addEventListener('load', function () { setTimeout(go, 300); });
    }
  }

  function init() {
    if (!window.EcoCatalog || !window.Eco) { el.innerHTML = '<p class="ec-muted">' + EcoT('core.no_se_pudo_cargar_recarga') + '</p>'; return; }
    el.innerHTML = '<p class="ec-muted">' + esc(T.loading || EcoT('catalogo.cargando_el_catalogo')) + '</p>';
    EcoCatalog.load(el.getAttribute('data-collection') || 'all').then(mount, function () { el.innerHTML = '<p class="ec-muted">'+EcoT('catalogo.no_se_ha_podido_cargar_el_catalogo_rec')+'</p>'; });
    // al cambiar el perfil o la personalización se vuelve a montar (salidas de la función 1)
    Eco.Profile.on(function () { if (window.PRODUCTS) mount(); });
  }
  // arranque robusto: espera a eco-core.js (se carga al final del body) sin depender del orden de DOMContentLoaded
  (function boot(n) { if (window.Eco || n > 200) init(); else setTimeout(function () { boot(n + 1); }, 30); })(0);
})();
